import loadjs from 'loadjs';
import config from 'appconfig';

export default () =>
  new Promise((resolve, reject) => {
    loadjs(config.tnsSessionUrl, { success: () => resolve(window.PaymentSession), error: reject });
  });
